import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './radio-group.magic.css.js';
import script from './radio-group.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-group",class:{
        'radio-group--space': _vm.space,
        'radio-group--left': _vm.left,
        'radio-group--right': _vm.right,
        'radio-group--inline': _vm.inline,
        'radio-group--column': _vm.column,
        'radio-group--inline-nowrap': _vm.inlineNowrap,
    },attrs:{"part":_vm.$p('radio-group', {
        'radio-group--space': _vm.space,
        'radio-group--left': _vm.left,
        'radio-group--right': _vm.right,
        'radio-group--inline': _vm.inline,
        'radio-group--column': _vm.column,
        'radio-group--inline-nowrap': _vm.inlineNowrap,
    })},on:{"register":_vm.register,"change":_vm.change,"input":function($event){$event.stopPropagation();},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.moveFocus(-1, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.moveFocus(1, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.moveFocus(-1, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.moveFocus(1, $event)}],"!focus":function($event){return _vm.focusCurrent($event)}}},[_c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7f4db712_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7f4db712";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
